import { render, staticRenderFns } from "./SubjectDeleteDialog.vue?vue&type=template&id=2d81e278"
import script from "./SubjectDeleteDialog.vue?vue&type=script&lang=js"
export * from "./SubjectDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports